import { render, staticRenderFns } from "./base-label.vue?vue&type=template&id=19cf06f5&scoped=true"
import script from "./base-label.vue?vue&type=script&lang=js"
export * from "./base-label.vue?vue&type=script&lang=js"
import style0 from "./base-label.vue?vue&type=style&index=0&id=19cf06f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cf06f5",
  null
  
)

export default component.exports